import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'localeDate' })
export class LocaleDatePipe implements PipeTransform {
	transform(date: any): string {
		if (!date) return date;

		return this.toLocal(date);
	}

	toLocal(date: any) {
		const toString = new Date(date).toLocaleString('en-US');
		const utc = new Date(toString + ' UTC');
		return utc.toLocaleString('en-US');
	}
}
